<template>
  <td :colspan="colspan">
    <slot></slot>
    <v-row>
      <template v-for="header in headers">
        <v-col :key="header.value" cols="12" sm="6">
          <span class="text-subtitle-2">
            {{ header.text }}
          </span>
          <br />
          <slot :name="`item.${header.value}`">
            <span v-if="getProperty(item, header.value)">{{
              getProperty(item, header.value)
            }}</span>
            <span v-else>
              -
            </span>
          </slot>
        </v-col>
      </template>
    </v-row>
    <slot name="append"></slot>
  </td>
</template>

<script>
export default {
  name: 'BaseExpandedTableRow',

  props: {
    headers: {
      type: Array,
      default: () => [],
    },

    colspan: {
      type: Number,
      default: 1,
    },

    item: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    getProperty(object, propertyName) {
      const parts = propertyName.split('.');
      let property = object || this;

      for (let i = 0; i < parts.length; i += 1) {
        property = property[parts[i]];
      }

      return property;
    },
  },
};
</script>
